import './app.scss';
import Navbar from './components/Navbar';
import HeroPanel from './components/HeroPanel';
import InformationSection from './components/InformationSection';
import ContactInformation from './components/ContactInformation';
import Footer from './components/Footer';
import Visualizations from './components/Visualizations'

const informationSectionContentId = "information-section-content";
function App() {
  return (
    <div className="App">
        <Navbar/>
        <div className="app-content container white develop-content mt-3 mb-3" id="content">
            <HeroPanel/>
            <InformationSection id="info-text-expanded"/>
            <ContactInformation id="contact-info"/>
            <Footer/>
        </div>
    </div>
  );
}

// ReactDOM.render(config.callToAction.extendedText, document.getElementById("info-text-expanded"));

export default App;
